import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Panels Module Service Stores
 * Updated to match backend api-types
 */
export const panelsStores: ServiceStoreConfig[] = [
  {
    name: "panels",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      serviceView: {
        enableServiceView: true,
        actions: {
          enableInlineEdit: true,
          enableRemove: true,
        },
        summaryCards: (rootStore) => {
          const store = rootStore.panelsStore as { entities?: unknown[] };
          const entities = store?.entities || [];
          const totalPanels = entities.length;
          const completed = entities.filter(
            (panel: Record<string, unknown>) => panel.status === "completed" || panel.status === "shipped"
          ).length;
          const inProduction = entities.filter(
            (panel: Record<string, unknown>) => panel.status === "in_production" || panel.status === "casting"
          ).length;
          const uniqueProjects = new Set(
            entities.map((panel: Record<string, unknown>) => panel.projectId)
          ).size;

          return [
            {
              title: "Total Panels",
              value: () => totalPanels.toString(),
              valueColor: "primary.main",
            },
            {
              title: "Completed",
              value: () => completed.toString(),
              valueColor: "success.main",
            },
            {
              title: "In Production",
              value: () => inProduction.toString(),
              valueColor: "warning.main",
            },
            {
              title: "Unique Projects",
              value: () => uniqueProjects.toString(),
              valueColor: "info.main",
            },
          ];
        },
        permissions: {
          requiresAuth: true,
          requiresAdmin: false,
        },
      },
    },
  },
];
